module.exports = __webpack_public_path__ + "img/睡.3ce60933.png";